var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3527 4.84632L8.00003 1.77194L2.64734 4.84632V11.1537L8.00003 14.2281L13.3527 11.1537V4.84632ZM11.9437 5.11816L8.00003 7.38322L4.05637 5.11816L8.00003 2.85307L11.9437 5.11816ZM3.58484 5.92844L7.53128 8.19513V12.8777L3.58484 10.611V5.92844ZM8.46878 12.8777V8.19513L12.4152 5.92844V10.611L8.46878 12.8777Z",
    fill: "#505258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 0.9375H3.51628V0H0V3.50678H0.9375V0.9375Z",
    fill: "#505258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9375 12.4837H0V16H3.50678V15.0625H0.9375V12.4837Z",
    fill: "#505258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4838 0V0.9375H15.0625V3.50678H16V0H12.4838Z",
    fill: "#505258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0624 15.0625H12.4932V16H15.9999V12.4837H15.0624V15.0625Z",
    fill: "#505258"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssIcon);
export default __webpack_public_path__ + "static/media/essIcon.fdac1e22b48db34b9ece984a11e98216.svg";
export { ForwardRef as ReactComponent };